import { render, staticRenderFns } from "./CreationConfiguration.vue?vue&type=template&id=be7e1a80&"
import script from "./CreationConfiguration.vue?vue&type=script&lang=js&"
export * from "./CreationConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports